import { Directive, OnDestroy, inject, ChangeDetectorRef } from '@angular/core';
import { MediaChange, MediaObserver } from '@ngbracket/ngx-layout';
import { MatGridList } from '@angular/material/grid-list';
import { Subscription } from 'rxjs';

@Directive({
    selector: 'mat-grid-list[tnbResponsiveGrid]',
    standalone: false,
})
export class ResponsiveGridDirective implements OnDestroy {
    private mdGridList = inject(MatGridList);
    private mediaObserver = inject(MediaObserver);
    private changeDetectorRef = inject(ChangeDetectorRef);

    private readonly defaultCols = 1;
    private readonly gridCols = {
        'xs': 1,
        'sm': 2,
        'md': 3,
        'lg': 3,
        'xl': 5,
    };
    private readonly media$: Subscription;

    constructor() {
        this.mdGridList.cols = this.queryCols() || this.defaultCols;

        this.media$ = this.mediaObserver.asObservable().subscribe((change: MediaChange[]) => {
            this.mdGridList.cols = this.gridCols[change[0].mqAlias] || this.defaultCols;
            this.changeDetectorRef.markForCheck();
        });
    }

    ngOnDestroy() {
        this.media$.unsubscribe();
    }

    private queryCols(): number {
        for (const size in this.gridCols) {
            if (this.mediaObserver.isActive(size)) {
                return this.gridCols[size];
            }
        }
        return null;
    }
}
